import { Components } from '../../../../component-classes';
import { ActionRuleParams } from '../../types';
import { syncAccessorySkuCount } from '../../helpers';

import type { Island } from '../../../islands/island.class';
import type { Panel } from '../../../panels/panel.class';
import type { PanelItemGroup } from '../../../panel-item-groups/panel-item-group.class';
import type { PanelItem } from '../../../panel-items/panel-item.class';

const SKU = 'CUSTOM_NONCOY_COUNTERTOP_CUTOUT';

const isNonCoyoteCountertopCutout = (panelItem: PanelItem): boolean => {
	const { item } = panelItem;
	const { vendor, placement, category } = item;

	// Must be a non-Coyote item (custom appliances have no vendor — treat as non-Coyote)
	if (vendor?.displayValue === 'Coyote') return false;

	// Must be a top-only countertop appliance (Drop-in.. ie - Sink)
	if (placement !== Components.PLACEMENT_TOP_ONLY) return false;

	// Exclude plain cutout and circular cutout category items (handled by opening-in-counter rule)
	if (category?.key === 'cutout' || category?.key === 'hole') return false;

	// Exclude system items (vents, passthroughs) and outlets
	if (category?.key === 'vent' || category?.key === 'passthrough' || category?.key === 'system' || category?.key === 'outlet') return false;

	// Exclude stand-alone items (e.g. pizza ovens)
	if (panelItem.isStandAlone) return false;

	return true;
};

export const nonCoyoteCountertopCutout = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const islands = refMap.islands ?? kitchen.design?.islands ?? null;
	if (!islands) return;

	let qualifyingCount = 0;

	for (const child of islands.children) {
		const island = child as Island;

		for (const panel of island.panels.children) {
			const typedPanel = panel as Panel;

			for (const group of typedPanel.panelItemGroups.children) {
				const typedGroup = group as PanelItemGroup;

				for (const panelItem of typedGroup.items.children) {
					if (isNonCoyoteCountertopCutout(panelItem as PanelItem)) {
						qualifyingCount++;
					}
				}
			}
		}
	}

	syncAccessorySkuCount({ kitchen, sku: SKU, qualifyingCount });
};
